import angular from "angular";
import "angular-messages";
import "angular-sanitize";
import "angular-ui-mask";
import { membershipContactPhoneNumber } from "../constants";
import communicationPreferences from "../directives/communicationPreferencesDirective";
import floatLabels from "../directives/floatLabelsDirective";
import pageDriver from "../directives/pageDriverDirective";
import validateDateOfBirth from "../directives/validateDateOfBirthDirective";
import validateEmail from "../directives/validateEmailDirective";
import validatePassword from "../directives/validatePasswordDirective";
import validatePhoneNumber from "../directives/validatePhoneNumberDirective";
import validateUsername from "../directives/validateUsernameDirective";
import agreementService from "../services/agreementService";
import "../services/commprefs-services";
import "../services/myaccount-services";
import navigationService from "../services/navigationService";
import profileValue from "../services/profileValue";
import { AgreementParserFactory } from "./agreements/AgreementParserFactory";

export default function (
  moduleName: string,
  controller: ng.Injectable<ng.IControllerConstructor>
): ng.IModule {
  const module = angular
    .module(moduleName, [
      "ngMessages",
      "ngSanitize",
      "ui.mask",
      "ltt.myaccount.api",
      "ltt.commprefs.api",
    ])
    .value("Profile", profileValue)
    .controller("MainController", controller)
    .factory("agreementService", agreementService)
    .service("navigationService", navigationService)
    .service("agreementParserFactory", AgreementParserFactory)
    .filter("abs", () => {
      return (val: number) => {
        return Math.abs(val);
      };
    })
    .filter("dateFormater", () => {
      return (input: string | null) => {
        if (!input) {
          return "";
        }

        // breaks DB date to array
        const parts = input.split(/[-]/).filter((str: string) => {
          return str !== "";
        });
        // Takes date with time and returns array with date at 0th position
        const date = parts[2].split(/[ ]/).filter((str: string) => {
          return str !== "";
        });

        return `${parts[1]}-${date[0]}-${parts[0]}`;
      };
    })
    .filter("fcap", () => {
      return (token: string) => {
        return (
          token.charAt(0).toUpperCase() + token.slice(1).toLocaleLowerCase()
        );
      };
    })
    .filter("gender", () => {
      return (token: string) => {
        if (token) {
          return token.toUpperCase() === "M" ? "Male" : "Female";
        } else {
          return "-";
        }
      };
    });

  pageDriver(module);
  communicationPreferences(module);
  floatLabels(module);
  validateDateOfBirth(module);
  validateEmail(module);
  validatePassword(module);
  validatePhoneNumber(module);
  validateUsername(module);

  module.config([
    "$httpProvider",
    ($httpProvider: ng.IHttpProvider): void => {
      $httpProvider.interceptors.push([
        "$q",
        "$rootScope",
        (
          $q: ng.IQService,
          $rootScope: IAccountRootScopeService
        ): ng.IHttpInterceptor => {
          return {
            responseError<T>(
              rejection: ng.IHttpResponse<T>
            ): ng.IHttpResponse<T> | ng.IPromise<ng.IHttpResponse<T>> {
              if (rejection.status === 500) {

                // TODO review other places where 500 error matters
                let errorMessage: string = rejection.statusText;

                const errorId: string | undefined = rejection.data
                  ? ((rejection.data as any).errorId as string)
                  : undefined;
                if (errorId) {
                  errorMessage += `. Error ID: ${errorId}`;
                }

                $rootScope.globalErrors.push({
                  type: "http-500",
                  message: errorMessage,
                });
              }

              return $q.reject(rejection);
            },
          };
        },
      ]);
    },
  ]);

  module.run([
    "$rootScope",
    ($rootScope: IAccountRootScopeService): void => {
      // constant for membership contact information
      $rootScope.constMembershipContactPhoneNumber =
        membershipContactPhoneNumber;

      $rootScope.globalErrors = [];
    },
  ]);

  return module;
}

interface IAccountRootScopeService extends ng.IRootScopeService {
  constMembershipContactPhoneNumber: string;
  globalErrors: { type: string; message: string }[];
}
